import React from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import classes from './TermsPage.module.css';
import { useNavigate } from 'react-router-dom';

const TermsPage = () => {
    const navigate=useNavigate();
    const onBack=()=>{
        navigate("/");
    }
  return (
    <div className={classes.pageWrapper}>
      <div className={classes.card}>
        <div className={classes.header}>
          <button className={classes.backButton} onClick={onBack}>
            <FaArrowLeft size={20} />
          </button>
          <h2 className={classes.productTitle}>Door 2 Games</h2>
        </div>

        <h1 className={classes.heading}>Terms & Conditions</h1>
        <ul className={classes.list}>
          {/* <li>The service has 3 packs (Daily, Weekly and Monthly).</li> */}
          <li>The service has 1 Daily Pack.</li>
          <li>Your Subscription will be renewed based on your subscription pack, automatically until you unsubscribe.</li>
          <li>You can unsubscribe from the service anytime, by deactivating from the portal.</li>
          <li>All data-enabled features & Smartphone users can enjoy full service.</li>
          <li>Customer can access the content at any time during the subscription validity period.</li>
        </ul>
      </div>
    </div>
  );
};

export default TermsPage;
